import { ROUTE_PATHS_WITHOUT_AUTHOR_ROW } from 'modules/routes/constants/index.cjs'

export default function hasAuthorRowRouteUtil (pathname) {
  return !ROUTE_PATHS_WITHOUT_AUTHOR_ROW.some(
    pathWithoutAuthorRow => !pathname.indexOf(pathWithoutAuthorRow)
  )
}
